export enum StockStatsIntervalEnum {
    MIN_1       = '1min',
    MIN_5       = '5min',
    LIVE        = 'live',
}
